import { render, staticRenderFns } from "./preConference.vue?vue&type=template&id=3372b4ff&scoped=true"
import script from "./preConference.vue?vue&type=script&setup=true&lang=ts"
export * from "./preConference.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./preConference.vue?vue&type=style&index=0&id=3372b4ff&prod&lang=css"
import style1 from "./preConference.vue?vue&type=style&index=1&id=3372b4ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372b4ff",
  null
  
)

export default component.exports